import { render, staticRenderFns } from "./PermissionAlert.vue?vue&type=template&id=30d46f5a&"
import script from "./PermissionAlert.vue?vue&type=script&lang=ts&"
export * from "./PermissionAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports